import { gql } from '@apollo/client';

export const PROCESS_CENSUS = gql`
  query CENSUS_SERVICE_processCensus($groupId: ID!, $periodId: ID!) {
    processCensus(groupId: $groupId, periodId: $periodId) {
      headers
      statistics {
        total
        employees
        dependents
        errors
      }
      families {
        row
        memberType
        invalid
        status
        cells {
          header
          value
          warningMessage
          errorMessage
        }
      }
    }
  }
`;

export const PROCESS_GROUP_CENSUS = gql`
  query CENSUS_SERVICE_processGroupCensus($groupId: ID!) {
    processGroupCensus(groupId: $groupId) {
      headers
      statistics {
        total
        employees
        dependents
        errors
      }
      families {
        row
        memberType
        invalid
        status
        cells {
          header
          value
          warningMessage
          errorMessage
        }
      }
    }
  }
`;

export const DOES_ENROLLMENT_HAVE_CENSUS = gql`
  query CENSUS_SERVICE_doesEnrollmentHaveCensus($groupId: ID!, $periodId: ID!) {
    doesEnrollmentHaveCensus(groupId: $groupId, periodId: $periodId) {
      exist
      valid
      familyAmount
      hasPrePopulatedCensus
    }
  }
`;

export const DOES_GROUP_HAVE_CENSUS = gql`
  query CENSUS_SERVICE_doesGroupHaveCensus($groupId: ID!) {
    doesGroupHaveCensus(groupId: $groupId) {
      exist
      valid
      familyAmount
      hasPrePopulatedCensus
    }
  }
`;

export const SUBMIT_CENSUS = gql`
  mutation CENSUS_SERVICE_submitCensus($groupId: ID!, $periodId: ID!) {
    submitCensus(groupId: $groupId, periodId: $periodId)
  }
`;

export const SUBMIT_GROUP_CENSUS = gql`
  mutation CENSUS_SERVICE_submitGroupCensus($groupId: ID!) {
    submitGroupCensus(groupId: $groupId)
  }
`;

export const GET_CENSUS_DOWNLOAD_URLS = gql`
  query CENSUS_SERVICE_getCensusDownloadUrls($groupId: ID!, $periodId: ID!) {
    getCensusDownloadUrls(groupId: $groupId, periodId: $periodId)
  }
`;

export const GET_GROUP_CENSUS_DOWNLOAD_URLS = gql`
  query CENSUS_SERVICE_getGroupCensusDownloadUrls($groupId: ID!) {
    getGroupCensusDownloadUrls(groupId: $groupId)
  }
`;

export const DOWNLOAD_PREPOPULATED_CENSUS_URLS = gql`
  query CENSUS_SERVICE_getPrepopulatedCensusDownloadUrl($groupId: ID!, $periodId: String!) {
    getPrepopulatedCensusDownloadUrl(groupId: $groupId, periodId: $periodId)
  }
`;
